var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-circular',{staticClass:"my-4",attrs:{"indeterminate":"","color":_vm.color,"size":_vm.size,"width":_vm.width,"aria-label":_vm.$t('common.loading'),"role":"status","data-qa":"loading-spinner"}})}
var staticRenderFns = []

export { render, staticRenderFns }